export default __webpack_public_path__ + "static/media/035-hedgehog.02d9cb01.svg";